var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E50A0",
    d: "M1.389 4.722H18.61v10.556H1.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.111 8.015v.874h2.828l4.672-2.864V4.722h-2.126z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M18.611 4.722h-1.063l-6.437 3.945v.222h.967l6.533-4.004z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.485 15.278h2.126v-1.303L13.94 11.11h-2.828v.873z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M18.611 15.278v-.652l-5.735-3.515h-1.33l6.799 4.167z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.889 11.985v-.874H6.06l-4.672 2.864v1.303h2.126z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M1.389 15.278h1.063l6.437-3.945v-.222h-.967l-6.533 4.004z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.515 4.722H1.389v1.303L6.06 8.89h2.828v-.873z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M1.389 4.722v.652L7.124 8.89h1.33L1.654 4.722z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.389 8.611H18.61v2.778H1.39z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.611 4.722h2.778v10.556H8.61z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M1.389 9.167H18.61v1.666H1.39z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    d: "M9.167 4.722h1.666v10.556H9.167z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag-uk.fa0c9c45a62eba8eca33ed05e8515d0c.svg";
export { ForwardRef as ReactComponent };